import Helmet from 'react-helmet'
import {
  Nav,
  Loading,
  SupportForm,
  EditStructuredData,
  EditLocalBusiness
} from 'components'
import { SEOSettingsActions } from 'actions'
import { SUPPORT_URL } from 'consts'
import IconButton from 'material-ui/IconButton'

const controlledSettings = [
  'pageTitleTruncateChars',
  'pageTitleEnableAppender',
  'pageTitleAppenderTemplate',
  'pageTitleAppenderTargetLength',
  'pageTitleTemplateApplyToAll',
  'metaDescriptionTruncateChars',
  'metaDescriptionTemplateApplyToAll',
  'structuredDataSocialProfileLinks',
  'structuredDataReviewApp',
  'structuredDataDisplayLocalBusiness',
  'structuredDataBusinessName',
  'structuredDataShopUrl',
  'structuredDataBusinessEmail',
  'structuredDataContactPhone',
  'structuredDataStreet',
  'structuredDataLocality',
  'structuredDataRegion',
  'structuredDataCountry',
  'structuredDataPostalCode'
]

export default class StructuredDataPage extends React.Component {
  static propTypes = {
    settings:         React.PropTypes.object,
    fetching:         React.PropTypes.bool,
    shopDetails:      React.PropTypes.object,
    noShopDetails:    React.PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.state = { hasLogo: false }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.settings) return

    this.setState({ hasLogo: nextProps.settings['structuredDataDisplayLogo'] })
  }

  save(data, callback) {
    let settings = {}
    controlledSettings.forEach((setting) => {
      settings[setting] = data[setting]
    })
    return SEOSettingsActions.update(settings, callback)
  }

  render() {
    if (!this.props.settings) {
      return (
        <div>
          <Helmet title="Structured Data - Plug in SEO Plus" />
          <Nav toolbarTitleText="Structured Data" />
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Helmet title="Structured Data - Plug in SEO Plus" />
        <Nav 
          toolbarTitleText="Structured Data" 
          rightGroupComponents={[
            <a href="https://support.pluginuseful.com/hc/en-us/sections/23534787532564-JSON-LD-Structured-Data" target="_blank">
              <IconButton 
                tooltip='Learn More' 
                iconClassName="material-icons"
                iconStyle={{ color: '#FFFFFF' }}
              >
                info_outline
              </IconButton>
            </a>
          ]}
        />
        <div className="seosettings">
          <div className="seosettings__form-container">
            <EditStructuredData
              data={this.props.settings}
              onSave={this.save}
              saving={this.props.fetching}
            />
            {(this.props.shopDetails || this.props.noShopDetails) &&
              <EditLocalBusiness
                data={this.props.settings}
                details={this.props.shopDetails}
                noDetails={this.props.noShopDetails}
                onSave={this.save}
              />
            }
          </div>
          <div className="seosettings__feedback-container">
            <SupportForm
              href={SUPPORT_URL}
              featureType="SEO settings"
              featureKey="settings_structured-data"
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/plus/StructuredDataPage.js